import React from "react"
import PropTypes from "prop-types"

import { useTranslation } from "react-i18next"

import Delete from "components/GenericViews/Delete"
import { reverse } from "utils/urls"

export default function TourOperatorBookingDelete(props) {
  const { t } = useTranslation()

  return (
    <Delete
      modelName={t("Tour Operator Booking")}
      endpoint={`/bookings/tour-operator-bookings/${props.match.params.id}/`}
      successRoute={reverse("tourOperatorBookingList")}
      errorRoute={reverse("tourOperatorBookingList")}
    />
  )
}

TourOperatorBookingDelete.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
